import { useEffect } from "react";
import { useLocation, Outlet } from "react-router-dom";
import { motion, useScroll, useSpring } from "framer-motion";
import Navbar from "./Navbar";
import Footer from "./Footer";
import MissionStatement from "./MissionStatement";

export const Layout = () => {
    const { pathname } = useLocation();
    const { scrollYProgress } = useScroll();
    const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 22, restDelta: 0.001 });

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    }, [pathname]);

    return (
        <div className="min-h-screen flex flex-col bg-editorial">
            {/* Scroll progress bar */}
            <motion.div
                style={{ scaleX }}
                className="fixed top-0 left-0 right-0 h-[3px] bg-coral z-[60] origin-left"
                data-testid="scroll-progress"
            />
            <Navbar />
            <main className="flex-1 pt-20" id="main">
                <Outlet />
            </main>
            <MissionStatement />
            <Footer />
        </div>
    );
};

export default Layout;
